
import React from 'react';
import AnimatedCard from '@/components/ui/AnimatedCard';
import ChillerDetailCard from '@/components/energy/chillers/ChillerDetailCard';

const ChillerSystemsTab = () => {
  return (
    <div className="space-y-4 w-full h-full overflow-auto flex flex-col p-4">
      <AnimatedCard
        animation="fade-up"
        delay={150}
        className="border-none shadow-sm"
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <ChillerDetailCard id="1" />
          <ChillerDetailCard id="2" />
          <ChillerDetailCard id="3" />
        </div>
      </AnimatedCard>
    </div>
  );
};

export default ChillerSystemsTab;
